import { render, staticRenderFns } from "./FlexibleInvestment.vue?vue&type=template&id=2e677169&scoped=true&"
import script from "./FlexibleInvestment.vue?vue&type=script&lang=js&"
export * from "./FlexibleInvestment.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleInvestment.vue?vue&type=style&index=0&id=2e677169&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e677169",
  null
  
)

component.options.__file = "FlexibleInvestment.vue"
export default component.exports